<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const values = ['', 'present', 'absent', 'without_phone'];
const labels = computed(() => [
  t('WHATSAPP_IDENTITY.FILTER_ALL'),
  t('WHATSAPP_IDENTITY.FILTER_PRESENT'),
  t('WHATSAPP_IDENTITY.FILTER_ABSENT'),
  t('WHATSAPP_IDENTITY.FILTER_WITHOUT_PHONE'),
]);
const selected = computed(() =>
  values.includes(route.query.whatsapp_username)
    ? route.query.whatsapp_username
    : ''
);
const updateFilter = event => {
  const query = { ...route.query, page: '1' };
  if (event.target.value) query.whatsapp_username = event.target.value;
  else delete query.whatsapp_username;
  router.replace({ query });
};
</script>

<template>
  <label class="flex items-center gap-2 py-2 text-sm text-n-slate-11">
    <span>{{ t('WHATSAPP_IDENTITY.FILTER_LABEL') }}</span>
    <select
      :value="selected"
      class="h-8 text-sm rounded-lg border border-n-weak bg-n-solid-1 text-n-slate-12"
      @change="updateFilter"
    >
      <option v-for="(value, index) in values" :key="value" :value="value">
        {{ labels[index] }}
      </option>
    </select>
  </label>
</template>
